import { render, staticRenderFns } from "./CustomerStoreTable.vue?vue&type=template&id=5d0983aa&"
import script from "./CustomerStoreTable.vue?vue&type=script&lang=ts&"
export * from "./CustomerStoreTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QTd})
